import React from "react";
import styles from "./AdminChatBox.module.scss";
import ChatMessageBox from "./ChatMessageBox";
import { SonicMessage } from "../../common/classes/SonicMessage";
import ActionBtn from "../../common/management/ActionBtn";

export enum AdminChatBoxType {
  Loading = "Loading",
  ShowMessages = "ShowMessages",
  ReCreate = "ReCreate",
  ReCreating = "ReCreating",
  ReCreated = "ReCreated",
  FailedReCreate = "FailedReCreate",
  Error = "error",
}

type Props = {
  isDisplay: boolean;
  displayType: AdminChatBoxType;
  messages: Array<SonicMessage>;
  hasNext: boolean;
  handleLoad: (page: number) => Promise<void>;
  handleReCreateRoom: () => void;
};
const AdminChatBox: React.FC<Props> = ({
  isDisplay,
  displayType,
  messages,
  hasNext,
  handleLoad,
  handleReCreateRoom,
}) => {
  const switchBoxElement = (displayType: AdminChatBoxType) => {
    switch (displayType) {
      case AdminChatBoxType.ShowMessages:
        return messages.length > 0 ? (
          <ChatMessageBox
            pastMessages={messages}
            isFullHeight={true}
            hasNext={hasNext}
            handleLoad={handleLoad}
            clientEvent="load"
            setClientEvent={() => {}}
          />
        ) : (
          <p>メッセージがありません。</p>
        );
      case AdminChatBoxType.ReCreate:
        return (
          <>
            <p>チャットルームが見つかりませんでした。</p>
            <ActionBtn
              label="チャットルームを再作成する"
              onClick={handleReCreateRoom}
              colorReversal={true}
            />
          </>
        );
      case AdminChatBoxType.ReCreating:
        return <p>ルーム再作成中...</p>;
      case AdminChatBoxType.ReCreated:
        return <p>{`再作成しました。`}</p>;
      case AdminChatBoxType.FailedReCreate:
        return (
          <>
            <p>{`再作成は正常に完了しませんでした。\nブラウザをリロードすることでルームをご確認いただけます。`}</p>
            <ActionBtn
              label="チャットルームを再作成する"
              onClick={handleReCreateRoom}
              colorReversal={true}
            />
          </>
        );
      case AdminChatBoxType.Error:
        return <p>予期せぬエラーが発生しました。</p>;
      default:
        return <p>取得中...</p>;
    }
  };

  return (
    <>
      {isDisplay ? (
        <div className={styles["admin-chatbox"]}>
          {switchBoxElement(displayType)}
        </div>
      ) : null}
    </>
  );
};

export default AdminChatBox;
